"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpWithGoogleButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var single_1 = require("utils/selectors/single");
var GoogleButton_1 = __importDefault(require("../styles/GoogleButton"));
var SignUpWithGoogleButton = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    var authState = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    return ((0, jsx_runtime_1.jsx)(GoogleButton_1.default, __assign({ type: "button", disabled: disabled, onClick: onClick }, { children: (!(0, react_redux_firebase_1.isEmpty)(authState) && !(0, react_redux_firebase_1.isEmpty)(profile) && profile.companyId) ? 'Redirecting you...' : 'Sign up with Google' })));
};
exports.SignUpWithGoogleButton = SignUpWithGoogleButton;
exports.default = exports.SignUpWithGoogleButton;
